import { useStytchStore } from '@/stores/stytchStore'
import { Routes } from '../Routes'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

export default (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const stytch = useStytchStore()
    if (stytch.isAuthenticated) {
        return next({
            name: Routes.Home,
        })
    }

    return next()
}
